// Whole Component Tejashwini
import * as React from "react";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import RefundLogForm from "./RefundLogForm";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import TableSortLabel from "@mui/material/TableSortLabel";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Autocomplete } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
    cursor: "pointer",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    // backgroundColor: theme.palette.action.hover,
    cursor: "pointer",
  },
  "&:active": {
    backgroundColor: theme.palette.action.selected,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

export default function RefundLog() {
  let studentid;

  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [grades, setGrades] = useState([]);
  const [gradeAdmission, setGradeAdmission] = useState([]);
  const [sections, setSections] = useState([]);
  const [feeSlab, setFeeSlab] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "student_id",
    direction: "desc",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [academicYearId, setAcademicYearId] = useState("");
  const [oldPaymentData, setOldPaymentData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [gradeAdmissionName, setGradeAdmissionName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [feesSlabName, setFeesSlabName] = useState("");
  const [userId, setUserId] = useState();
  const [userMail, setUserMail] = useState();
  const [transportFees, setTransportFees] = useState([]);
  const [transportSlab, setTransportSlab] = useState();
  const navigate = useNavigate();
  const [studentID, setStudentID] = useState(null);
  const [studentName, setStudentName] = useState();
  const [loading, setLoading] = useState(false); // Loading state
  const [openForm, setOpenForm] = useState(false);

  const [openDialogs, setOpenDialogs] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          setUserMail(response.data.user.email_id);
          console.log("response", response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_JHS_DEVELOPMENT + "/grade/grade-section")
      .then((response) => {
        setGrades(response.data.grades); // ← no sort, keep as is
        const sortedSections = response.data.sections.sort((a, b) =>
          a.section_name.localeCompare(b.section_name),
        );
        setSections(sortedSections);
      })
      .catch((error) => {
        console.error("Error fetching grades:", error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/getFeeSlab")
      .then((response) => {
        const sorted = response.data.sort((a, b) =>
          a.fees_slab.localeCompare(b.fees_slab, undefined, {
            numeric: true,
            sensitivity: "base",
          }),
        );
        setFeeSlab(sorted);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          navigate("/signin");
        } else {
          console.error("Error fetching fee slab:", error);
        }
      });
  }, []);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_JHS_DEVELOPMENT + "/grade/grade-section")
      .then((response) => {
        setGradeAdmission(response.data.grades); // ← no sort, keep as is
        const sortedSections = response.data.sections.sort((a, b) =>
          a.section_name.localeCompare(b.section_name),
        );
        setSections(sortedSections);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          navigate("/signin");
        } else {
          console.error("Error fetching grade admission:", error);
        }
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          "/transportPayment/transportSlab",
      )
      .then((response) => {
        const sorted = response.data.sort((a, b) =>
          a.transport_slab_name.localeCompare(
            b.transport_slab_name,
            undefined,
            {
              numeric: true,
              sensitivity: "base",
            },
          ),
        );
        setTransportFees(sorted);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          navigate("/signin");
        } else {
          console.error("Error fetching transport slab:", error);
        }
      });
  }, []);

  const handleSubmit = (msg, severity) => {
    setSnackbarSeverity(severity);
    setSnackbarMessage(msg);
    setSnackbarOpen(true);
    fetchStudent();
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleGradeChange = (event) => {
    setSelectedGrade(event.target.value);
    console.log("Selected Grade:", event.target.value);
  };

  const handleSectionChange = (event) => {
    setSelectedSection(event.target.value);
    console.log("Selected Section:", event.target.value);
  };

  useEffect(() => {
    fetchStudent();
  }, [academicYearId]);

  useEffect(() => {
    fetchStudent();
  }, []);

  const fetchStudent = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/refundLog/getallstudent",
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: "include",
        },
      );
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin"); // Corrected path
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("API CALLED", data);
      setRows(data);
    } catch (error) {
      console.error("Error fetching fee payment data:", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    console.log("Updated studentID in useState:", studentID);
  }, [studentID]);

  const handleRowClick = (row) => {
    setOpenForm(true);
    setStudentID(row.student_id);
    setStudentName(row.full_name);
    console.log("uasestat data", studentID);
    console.log("local veriable data", row.student_id);

    axios
      .get(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          `/refundLogForm/getRefund?student_id=${studentid}`,
        { withCredentials: "true" },
      )
      .then((response) => {
        setSelectedStudent(response.data);
        setIsModalOpen(true);
        setOldPaymentData(response.data);
        console.log("Old Data", response.data);

        // Find the grade object where grade_id matches
        let selectedGrade1 = grades.find(
          (gr) => response.data.grade_id === gr.grade_id,
        );

        // Access the grade_name from the found grade object
        let selectedGradeName = selectedGrade1 ? selectedGrade1.grade_name : ""; // Fallback if grade is not found

        setGradeName(selectedGradeName);

        //Grade Admission

        let selectedGradeAdmission1 = gradeAdmission.find(
          (gr) => response.data.grade_of_admission === gr.grade_id,
        );

        // Access the grade_name from the found grade object
        let selectedGradeAdmissionName = selectedGradeAdmission1
          ? selectedGradeAdmission1.grade_name
          : ""; // Fallback if grade is not found

        setGradeAdmissionName(selectedGradeAdmissionName);

        //Section

        //Find the grade object where grade_id matches
        let selectedSection1 = sections.find(
          (sc) => response.data.section_id === sc.section_id,
        );

        // Access the grade_name from the found grade object
        let selectedSectionName = selectedSection1
          ? selectedSection1.section_name
          : "No section available"; // Fallback if grade is not found

        setSectionName(selectedSectionName);

        //Fees Slab
        let selectedFeesSlab1 = feeSlab.find(
          (fs) => response.data.fee_slab_id === fs.fees_slab_id,
        );
        // Access the grade_name from the found grade object
        let selectedFeesSlabName = selectedFeesSlab1
          ? selectedFeesSlab1.fees_slab
          : ""; // Fallback if grade is not found
        setFeesSlabName(selectedFeesSlabName);

        //Transport Fees
        let selectedTransportFees = transportFees.find(
          (fs) => response.data.transport_slab_id === fs.transport_slab_id,
        );
        // Access the grade_name from the found grade object
        let selectedTransportFeesName = selectedTransportFees
          ? selectedTransportFees.transport_slab_name
          : ""; // Fallback if grade is not found
        setTransportSlab(selectedTransportFeesName);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handleCloseModal = () => {
    console.log("local veriable data on model close", studentID);

    setSelectedStudent(null);
    setIsModalOpen(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const handleSort = (key) => {
    setSortConfig((prevConfig) => {
      let direction = "asc";
      if (prevConfig?.key === key && prevConfig?.direction === "asc") {
        direction = "desc";
      }
      return { key, direction };
    });
  };

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return rows; // Avoid sorting if no key is selected

    return [...rows].sort((a, b) => {
      const valueA = (a[sortConfig.key] || "").toString().toLowerCase();
      const valueB = (b[sortConfig.key] || "").toString().toLowerCase();

      if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [rows, sortConfig]);

  const filteredRows = React.useMemo(() => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    return sortedRows.filter((row) => {
      const matchesSearchTerms = searchTerms.every(
        (term) =>
          (row.student_id &&
            row.student_id.toString().toLowerCase().includes(term)) ||
          (row.full_name && row.full_name.toLowerCase().includes(term)) ||
          (row.last_name && row.last_name.toLowerCase().includes(term)) ||
          (row.father_name && row.father_name.toLowerCase().includes(term)) ||
          (row.mother_name && row.mother_name.toLowerCase().includes(term)) ||
          (row.email_id && row.email_id.toLowerCase().includes(term)) ||
          (row.contact_no && row.contact_no.toString().includes(term)) ||
          (row.fee_slab_id &&
            row.fee_slab_id.toString().toLowerCase().includes(term)),
      );

      return (
        (selectedGrade === "" || row.grade_id === selectedGrade) &&
        (selectedSection === "" || row.section_id === selectedSection) &&
        matchesSearchTerms
      );
    });
  }, [sortedRows, selectedGrade, selectedSection, searchQuery]);

  const paginatedRows = React.useMemo(() => {
    return filteredRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    );
  }, [filteredRows, page, rowsPerPage]);

  return (
    <>
      <Layout />

      <div>
        <h1 className="title">Refund Logs </h1>
      </div>

      <Container>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", marginBottom: "4px" }}>
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb: 0 }}
              placeholder="Search..."
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              style={{ marginBottom: "0", border: "none" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            {/* Grade Select with filter */}
            <Box sx={{ minWidth: 265, marginLeft: 1.3}}>
              <Autocomplete
                size="small"
                fullWidth
                options={grades}
                getOptionLabel={(option) => option.grade_name}
                value={grades.find((g) => g.grade_id === selectedGrade) || null}
                onChange={(event, newValue) => {
                  handleGradeChange({
                    target: { value: newValue ? newValue.grade_id : "" },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grade"
                    inputProps={{
                      ...params.inputProps,
                      style: {
                        textOverflow: "clip",
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.grade_name
                      .toLowerCase()
                      .includes(inputValue.toLowerCase()),
                  );
                }}
                noOptionsText="No matching grades"
                openOnFocus={false}
                clearOnEscape
              />
            </Box>
            <Box sx={{ minWidth: 100, marginLeft: 1.3}}>
              <FormControl fullWidth size="small">
                <InputLabel id="section-select-label">Section</InputLabel>
                <Select
                  labelId="section-select-label"
                  id="section-select"
                  value={selectedSection}
                  label="Section"
                  onChange={handleSectionChange}
                >
                  {sections.map((sections) => (
                    <MenuItem
                      key={sections.section_id}
                      value={sections.section_id}
                    >
                      {sections.section_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 600 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                {[
                  { key: "student_id", label: "Student ID", width: "150px" },
                  { key: "full_name", label: "Student Name", width: "200px" },
                  { key: "father_name", label: "Parent Name", width: "200px" },
                  { key: "email_id", label: "Email ID", width: "250px" },
                  { key: "contact_no", label: "Contact No", width: "150px" },
                ].map((column) => (
                  <StyledTableCell
                    key={column.key}
                    align="center"
                    sx={{ width: column.width }}
                  >
                    <TableSortLabel
                      active={sortConfig?.key === column.key}
                      direction={
                        sortConfig?.key === column.key
                          ? sortConfig?.direction
                          : "asc"
                      }
                      onClick={() => handleSort(column.key)}
                      sx={{
                        color:
                          sortConfig?.key === column.key ? "white" : "inherit",
                        display: "flex",
                        justifyContent: "center", // Ensures alignment
                        minWidth: column.width, // Prevents shifting
                      }}
                    >
                      {column.label}
                    </TableSortLabel>
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : (
                paginatedRows.map((row) => (
                  <StyledTableRow
                    key={row.student_id}
                    sx={{ backgroundColor: row.rte ? "#ffff88" : "inherit" }}
                    onClick={() => handleRowClick(row)}
                  >
                    <StyledTableCell align="center" sx={{ pr: "3em" }}>
                      {row.student_id}
                    </StyledTableCell>
                    <StyledTableCell align="center" sx={{ pr: "3em" }}>
                      {row.full_name}
                    </StyledTableCell>
                    <StyledTableCell align="center" sx={{ pr: "3em" }}>
                      {row.father_name
                        ? row.father_name
                        : row.mother_name || row.guardian_name}
                    </StyledTableCell>
                    <StyledTableCell align="center" sx={{ pr: "3em" }}>
                      {row.email_id}
                    </StyledTableCell>
                    <StyledTableCell align="center" sx={{ pr: "3em" }}>
                      {row.contact_no}
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          style={{ background: "#0A64A2", color: "#fff", width: "100%" }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <div
        // style={{
        //   background: "#fff",
        //   // maxHeight: "80vh",
        //   margin: "15%",
        //   width: "75%",
        //   height: 536,
        //   marginTop: "10em",
        //   position: "fixed",
        //   left: "0%",
        //   marginLeft: "14%",
        // }}
        >
          <RefundLogForm
            studentID={studentID}
            studentName={studentName}
            gradeName={gradeName}
            setGradeName={setGradeName}
            handleCloseModal={handleCloseModal}
            sectionName={sectionName}
          />
        </div>
      </Modal>

      <Snackbar
        style={{
          position: "absolute",
          top: "85%",
          left: "40%",
          textAlign: "center",
        }}
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert elevation={6} variant="filled" severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
